/* DDW Filter Wizard — ITR-293 v2 (proper fix, 2026-05-18) */
/* One-time first-visit walkthrough on /pages/diamonds                 */
/* Improvements vs v1:                                                  */
/*  - URL override: ?wizard=force bypasses guards, ?wizard=skip exits   */
/*  - Mobile threshold lowered 768 -> 600                               */
/*  - console.log markers at every guard + lifecycle event              */
/*  - Highlight ring 4px -> 6px gold                                    */
/*  - Real backdrop element (click-outside-to-dismiss)                  */
/*  - Progress badge in top-right corner ("Tour . 1 of 4")              */
/*  - Tooltip edge detection (flip left if would overflow right)        */
/*  - ESC key dismiss                                                   */
/*  - scrollIntoView for off-screen targets                             */
/*  - Nivoda wait timeout bumped 10s -> 15s                             */
(function() {
  'use strict';

  var STORAGE_KEY = 'ddw_wizard_seen';
  var MOBILE_MAX = 600;
  var qs = window.location.search;
  var FORCE = /[?&]wizard=force\b/.test(qs);
  var SKIP  = /[?&]wizard=skip\b/.test(qs);
  function LOG(m) { try { console.log('[ddw-wizard] ' + m); } catch (e) {} }

  LOG('init (viewport=' + window.innerWidth + 'px, force=' + FORCE + ', skip=' + SKIP + ')');

  if (SKIP) { LOG('exit: ?wizard=skip'); return; }
  if (!FORCE && localStorage.getItem(STORAGE_KEY) === '1') {
    LOG('exit: already seen (use ?wizard=force to override)');
    return;
  }
  if (!FORCE && window.innerWidth <= MOBILE_MAX) {
    LOG('exit: viewport too narrow (' + window.innerWidth + 'px <= ' + MOBILE_MAX + 'px). Use ?wizard=force to override.');
    return;
  }
  LOG('proceeding');

  var STEPS = [
    {
      selector: '.diamond-proxy-shape-filter',
      title: 'Choose Your Shape',
      body: 'Pick the diamond shape you love - Round, Oval, Emerald, and more.'
    },
    {
      selector: '.diamond-proxy-carat-filter',
      title: 'Set Your Carat Weight',
      body: 'Drag the slider to filter by size. 0.70-1.00ct is the sweet spot for value.'
    },
    {
      selector: '.diamond-proxy-colour-filter',
      title: 'Pick Your Colour Grade',
      body: 'D is colourless (rarest). G-H looks identical but costs less.'
    },
    {
      selector: '.diamond-proxy-price-filter',
      title: 'Set Your Budget',
      body: 'Filter by ZAR price. All prices are transparent - no hidden fees.'
    }
  ];

  var currentStep = 0;
  var highlight = null, tooltip = null, backdrop = null, badge = null;

  function injectStyles() {
    var s = document.createElement('style');
    s.id = 'ddw-wiz-styles';
    s.textContent = [
      '.ddw-wiz-backdrop { position: fixed; inset: 0; background: transparent; z-index: 9997; cursor: pointer; }',
      '.ddw-wiz-highlight { position: absolute; border-radius: 8px; box-shadow: 0 0 0 6px #C8A45C, 0 0 0 9999px rgba(0,0,0,.55); z-index: 9999; pointer-events: auto; transition: all .3s cubic-bezier(.4,0,.2,1); animation: ddwWizFadeIn .3s ease-out; }',
      '.ddw-wiz-tooltip { position: absolute; z-index: 10000; background: #FFFFFF; border: 1px solid #C8A45C; border-radius: 10px; padding: 18px 20px 16px; width: 260px; box-shadow: 0 8px 32px rgba(0,0,0,.4); font-family: "Inter", sans-serif; animation: ddwWizFadeIn .3s ease-out .1s both; }',
      '.ddw-wiz-tooltip::before { content: ""; position: absolute; top: 20px; border: 8px solid transparent; }',
      '.ddw-wiz-tooltip.ddw-wiz-tip-right::before { left: -9px; border-right-color: #C8A45C; border-left: none; }',
      '.ddw-wiz-tooltip.ddw-wiz-tip-left::before  { right: -9px; border-left-color:  #C8A45C; border-right: none; }',
      '.ddw-wiz-step { font-size: 9px; font-weight: 900; letter-spacing: .18em; text-transform: uppercase; color: #C8A45C; margin-bottom: 6px; }',
      '.ddw-wiz-title { font-family: "Cormorant Garamond", serif; font-size: 16px; font-weight: 700; color: #0A0A0A; margin-bottom: 8px; }',
      '.ddw-wiz-body { font-size: 12px; color: #6B6558; line-height: 1.6; margin-bottom: 14px; }',
      '.ddw-wiz-footer { display: flex; align-items: center; justify-content: space-between; }',
      '.ddw-wiz-skip { font-size: 10px; color: #6B6558; cursor: pointer; text-decoration: underline; background: none; border: none; padding: 0; font-family: "Inter", sans-serif; }',
      '.ddw-wiz-next { background: #C8A45C; color: #FAF8F3; border: none; border-radius: 50px; padding: 7px 18px; font-size: 10px; font-weight: 900; letter-spacing: .1em; text-transform: uppercase; cursor: pointer; font-family: "Inter", sans-serif; transition: background .2s; }',
      '.ddw-wiz-next:hover { background: #B8943C; }',
      '.ddw-wiz-dots { display: flex; gap: 5px; }',
      '.ddw-wiz-dot { width: 6px; height: 6px; border-radius: 50%; background: rgba(200,164,92,.3); }',
      '.ddw-wiz-dot.active { background: #C8A45C; }',
      '.ddw-wiz-badge { position: fixed; top: 24px; right: 24px; z-index: 10001; background: rgba(10,10,10,.85); color: #C8A45C; font-family: "Inter", sans-serif; font-size: 10px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; padding: 8px 14px; border-radius: 50px; border: 1px solid #C8A45C; backdrop-filter: blur(8px); animation: ddwWizFadeIn .4s ease-out; }',
      '@keyframes ddwWizFadeIn { from { opacity: 0; } to { opacity: 1; } }'
    ].join('\n');
    document.head.appendChild(s);
    LOG('styles injected');
  }

  function showStep(index) {
    cleanupStep();
    if (index >= STEPS.length) { finish(); return; }
    var step = STEPS[index];
    var target = document.querySelector(step.selector);
    if (!target) {
      LOG('step ' + (index + 1) + ' (' + step.selector + ') not found, skipping');
      showStep(index + 1);
      return;
    }
    LOG('step ' + (index + 1) + ': ' + step.title);

    // Scroll into view if needed
    var rect = target.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Re-measure after a tick to let scroll settle
      setTimeout(function() { renderStep(index, target); }, 350);
      return;
    }
    renderStep(index, target);
  }

  function renderStep(index, target) {
    var step = STEPS[index];
    var rect = target.getBoundingClientRect();
    var pad = 6;

    // Backdrop: invisible click-catcher
    backdrop = document.createElement('div');
    backdrop.className = 'ddw-wiz-backdrop';
    backdrop.addEventListener('click', function(e) {
      if (e.target === backdrop) {
        LOG('dismissed: clicked backdrop');
        finish();
      }
    });
    document.body.appendChild(backdrop);

    // Highlight ring (absorb clicks, no behavior)
    highlight = document.createElement('div');
    highlight.className = 'ddw-wiz-highlight';
    highlight.style.cssText =
      'top:'    + (rect.top    + window.scrollY - pad) + 'px;' +
      'left:'   + (rect.left   + window.scrollX - pad) + 'px;' +
      'width:'  + (rect.width  + pad * 2) + 'px;' +
      'height:' + (rect.height + pad * 2) + 'px;';
    highlight.addEventListener('click', function(e) { e.stopPropagation(); });
    document.body.appendChild(highlight);

    // Tooltip
    tooltip = document.createElement('div');
    var dots = STEPS.map(function(_, i) {
      return '<span class="ddw-wiz-dot' + (i === index ? ' active' : '') + '"></span>';
    }).join('');
    var isLast = index === STEPS.length - 1;
    tooltip.innerHTML =
      '<div class="ddw-wiz-step">Step ' + (index + 1) + ' of ' + STEPS.length + '</div>' +
      '<div class="ddw-wiz-title">' + step.title + '</div>' +
      '<div class="ddw-wiz-body">' + step.body + '</div>' +
      '<div class="ddw-wiz-footer">' +
        '<div class="ddw-wiz-dots">' + dots + '</div>' +
        '<div style="display:flex;gap:10px;align-items:center;">' +
          '<button class="ddw-wiz-skip">Skip</button>' +
          '<button class="ddw-wiz-next">' + (isLast ? 'Done' : 'Next') + '</button>' +
        '</div>' +
      '</div>';

    // Edge detection: tooltip on right if room, otherwise flip to left
    var tipNeeded = 260 + 40;
    var rightAvail = window.innerWidth - rect.right;
    var placeRight = rightAvail >= tipNeeded;
    tooltip.className = 'ddw-wiz-tooltip ' + (placeRight ? 'ddw-wiz-tip-right' : 'ddw-wiz-tip-left');
    document.body.appendChild(tooltip);

    if (placeRight) {
      tooltip.style.left = (rect.right + window.scrollX + pad + 12) + 'px';
      tooltip.style.top  = (rect.top   + window.scrollY + pad) + 'px';
    } else {
      var tipW = tooltip.offsetWidth || 280;
      tooltip.style.left = (rect.left + window.scrollX - tipW - pad - 12) + 'px';
      tooltip.style.top  = (rect.top  + window.scrollY + pad) + 'px';
    }

    tooltip.querySelector('.ddw-wiz-next').addEventListener('click', function() {
      currentStep++;
      showStep(currentStep);
    });
    tooltip.querySelector('.ddw-wiz-skip').addEventListener('click', function() {
      LOG('dismissed: clicked Skip');
      finish();
    });

    // Progress badge (top-right corner)
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'ddw-wiz-badge';
      document.body.appendChild(badge);
    }
    badge.textContent = 'Tour . ' + (index + 1) + ' of ' + STEPS.length;
  }

  function cleanupStep() {
    if (highlight) { highlight.remove(); highlight = null; }
    if (tooltip)   { tooltip.remove();   tooltip = null; }
    if (backdrop)  { backdrop.remove();  backdrop = null; }
  }

  function finish() {
    cleanupStep();
    if (badge) { badge.remove(); badge = null; }
    if (!FORCE) { localStorage.setItem(STORAGE_KEY, '1'); }
    LOG('finished (localStorage flag ' + (FORCE ? 'NOT set due to ?wizard=force' : 'set') + ')');
  }

  // ESC key to dismiss
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && (highlight || tooltip)) {
      LOG('dismissed: ESC');
      finish();
    }
  });

  function waitForNivoda(cb, tries) {
    tries = tries || 0;
    if (tries > 60) {
      LOG('timeout: Nivoda did not render .diamond-proxy-shape-filter within 15s');
      return;
    }
    var ready = document.querySelector('.diamond-proxy-shape-filter');
    if (ready) {
      LOG('Nivoda ready after ' + (tries * 250) + 'ms');
      cb();
    } else {
      setTimeout(function() { waitForNivoda(cb, tries + 1); }, 250);
    }
  }

  injectStyles();
  waitForNivoda(function() {
    setTimeout(function() { showStep(0); }, 800);
  });

})();